
import { Card, Col, Divider, Form, Input, Row, Space,Select } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import ButtonAction from 'components/Common/ButtonAction';
import { ButtonAdd } from 'components/Common/Buttons';
import useTopbarTitleHooks from 'hooks/useTopbarTitleHooks';
import CustomAntdTable from 'components/Common/CustomAntdTable';
import { dismissToast, errorToast, successToast,loadingToastId } from 'utils/Toast';
import Constant from 'utils/Constants';
import { sorterTable } from 'utils/Helper';
import useIsMobileHooks from 'hooks/useIsMobileHooks';
import { PRIVILEGE_ID } from 'utils/AccessPermissionConfig';
import SkeletonPage from 'components/Common/SkeletonPage';
import { ButtonAdvanceFilter } from 'components/Common/ButtonAdvanceFilter';
import Error403 from 'components/Error/Error403';
import BaseAdvanceFilter from 'components/CustomDrawer/BaseAdvanceFilter';
import CellTable from 'components/Common/CellTable';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTE_PREFIX, RouteConstant } from 'routes/routesConstant';
import useRoleRepo from "../../../services/repo/useRoleRepo";

export default function Role() {

    useTopbarTitleHooks("Role");
    const { isLoading: isLoadingList, getRoleList } = useRoleRepo(false)
    const { isLoading: isLoadingDelete,  deleteRole} = useRoleRepo(false);
    

    const isMobile = useIsMobileHooks()
    const [form] = Form.useForm()
    const navigate = useNavigate();
    const [data, setData] = useState()
    const [totalData, setTotalData] = useState(0)
    const [isOpenAdvanceFilter, setIsOpenAdvanceFilter] = useState(false)

    const isLoadingPrivilege = useRef(true)
    const hasPrivilegePage = useRef(true)
    const [isLoadedPrivilege, setIsLoadedPrivilege] = useState(false)
    const [showButtonAdd, setShowButtonAdd] = useState(false)

    const [filters, setFilters] = useState({
        roleName: "",
        status: "true"
    })

    const [tableParams, setTableParams] = useState({
        pageNumber: 1,
        pageSize: 10,
        filter: { ...filters },
        orderBy: "roleId",
        isAscending: true
    });

    const onSearch = (value) => {
        setTableParams(prev => ({
            ...prev,
            pageNumber: 1,
            filter: {
                ...filters
            }
        }))
    };

    const onSearchClick = () => {
        onSearch()
        setIsOpenAdvanceFilter(false)
    }

    const fetchData = async () => {
      
        const payload = {
            ...tableParams
        }
        const res = await getRoleList(payload)
        if (res?.detail=='OK' && res?.status === 200) {
            setData(res?.data?.content)
            setTotalData(res?.data?.totalElements)
        }
    };

   const handleTableChange = (pagination, filters, sorter) => {
           setTableParams(prevParams => ({
               ...prevParams,
               pageNumber: pagination?.current,
               pageSize: pagination?.pageSize,
               orderBy: sorter?.field || prevParams?.orderBy,
               isAscending: sorterTable(sorter?.order, prevParams?.isAscending)
           }));
           if (pagination.pageSize !== tableParams?.pageSize) {
               setData([]);
           }
    };


    const handleAdd = () => {
        navigate(APP_ROUTE_PREFIX + "/" + RouteConstant.userManagement.role.create);
    }

    // const handleEdit = async (data) => {
    //     alert(data)
    //     navigate(APP_ROUTE_PREFIX + "/" + RouteConstant.userManagement.role.edit(data?.roleId))
    // }

    const handleEdit = async (data) => {
        const key = 'loadingEdit';
        loadingToastId(Constant.message.loading, key)
        navigate(APP_ROUTE_PREFIX + "/" + RouteConstant.userManagement.role.edit(data?.roleId));
        dismissToast(key)
    }

    const fetchCheckPrivilege = async () => {
        setShowButtonAdd('Add')
        isLoadingPrivilege.current = false
        hasPrivilegePage.current = true;
        setIsLoadedPrivilege(true)
        fetchData();
        dismissToast(PRIVILEGE_ID.AddEditRole);
    }

    const handleDelete = async (record) => {
        const key = 'deleteRole';
        try {

          debugger
        
          loadingToastId(Constant.message.loading, key)
      
          const response = await deleteRole({ roleId: record.roleId });
      
          if (response?.status === 200 && response?.detail === 'OK') {
            successToast(Constant.message.deleteDataSuccess);
            fetchData(); 
          } else {
            errorToast(Constant.message.deleteDataFail);
          }
        } catch (error) {
          console.error('Error:', error);
          errorToast(Constant.message.deleteDataFail);
        } finally {
            dismissToast(key); 
          }
    };

    const handleToggleStatusCheckbox = async (record, checked) => {
        //const newStatus = checked ? "true" : "false";
        const response = await deleteRole({ roleId: record.roleId });

        if (response?.status === 200 && response?.detail === 'OK') {
            successToast("Status berhasil diubah.");
            fetchData();
        } else {
            errorToast("Gagal mengubah status.");
        }
    };


    useEffect(() => {
        fetchCheckPrivilege()
    }, [])

    useEffect(() => {
      
        if (isLoadedPrivilege) {
            fetchData();
        }
    }, [JSON.stringify(tableParams)]);

    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (isLoadedPrivilege && !isMobile) {
                onSearch()
            }
        }, Constant.delayFilter);
        return () => clearTimeout(timeOutId);
    }, [filters]);

    const filterUI = () => {
        return (
            <Form layout="horizontal" form={form}>
                <Row gutter={16}>
                    <Col xs={24} sm={10} md={8}>
                        <Form.Item name='roleNameFilter' label="Filter By">
                            <Input
                                allowClear
                                placeholder={Constant.placeholder.enterName}
                                onChange={(e) => {
                                    setFilters(prev => ({
                                        ...prev,
                                        roleName: e.target.value
                                    }))
                                }}
                            />
                        </Form.Item>
                    </Col>
                  
                </Row>
            </Form>
        )
    }

    const columns = [
        {
            title: 'Action',
            key: 'action',
            width: "60px",
            render: (_, record) => {
                // const buttons = showButtonAdd ? ['edit', 'toggleStatus'] : ['toggleStatus']
                return (
                    <ButtonAction
                        buttons={['edit']}
                        onEdit={handleEdit}
                        // onDelete={handleDelete}
                        loadingDelete={isLoadingDelete}
                        data={record}
                    />
                )
            }
        },
        {
            title: 'Name',
            dataIndex: 'roleName',
            sorter: true,
            width: "200px",
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Status',
            dataIndex: 'status',
            width: "150px",
            render: (data) => <CellTable data={data === "true" ? "Active" : "Inactive"} />
        }
    ];
    return (
        <>
            {hasPrivilegePage.current ?
                <Space direction="vertical" size="large" className='space-vertical-flex'>
                    <Card size="big" bordered={false}>
                        {isLoadingPrivilege.current ? <SkeletonPage /> :
                            <>
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={20} xl={18}>
                                        {showButtonAdd && <ButtonAdd onClick={handleAdd} />}
                                    </Col>
                                </Row>
                                <Divider dashed className='mb-1 mt-1' />

                                {isMobile ?
                                    <ButtonAdvanceFilter onClick={() => setIsOpenAdvanceFilter(true)} />
                                    : filterUI()
                                }

                                <CustomAntdTable
                                    columns={columns}
                                    dataSource={data}
                                    rowKey={"roleId"}
                                    tableParam={tableParams}
                                    totalData={totalData}
                                    loading={isLoadingList}
                                    onChange={handleTableChange}
                                />
                            </>
                        }
                    </Card>
                </Space> : (<Error403 />)
            }

            {isOpenAdvanceFilter &&
                <BaseAdvanceFilter
                    onClose={() => setIsOpenAdvanceFilter(false)}
                    onSearchClick={onSearchClick}>
                    {filterUI()}
                </BaseAdvanceFilter>}
        </>
    )
}
